import {APIError} from '../core/errors';
import httpClient from '../services/http.service';
import {getAccessToken} from '../core/localstorage-data';
import {BASE_URL, DEFAULT_HEADERS} from './api-constants';

const _api_base_url = `${BASE_URL}/lmr/store-information`;

const getAuthHeaders = () => ({
  ...DEFAULT_HEADERS,
  //Authorization: `Bearer ${getAccessToken()}`,
});

interface FetchStoreInformationPayload {
  store_input_code?: string | null;
  store_code?: string | null;
  mobile_number?: string | null;
}
interface StoreInformationResponse {
  resultCode: string;
  message: string;
  result: boolean;
  entity: string;
  store_code: string;
  store_name: string;
  pincode: string;
  latitude: string;
  longitude: string;
  server_ip: string;
  store_open_timings: string;
  store_close_timing: string;
}

export const getStoreInformation = async (
  payload: FetchStoreInformationPayload,
): Promise<StoreInformationResponse> => {
  try {
    const response = await httpClient.post(`${_api_base_url}`, payload, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    throw new APIError(error);
  }
};
